import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

const LOGO_URL = "/logo.png";

export default function Adatvedelmi() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#0A0F1C] text-white">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0A0F1C]/95 backdrop-blur sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="PálffyVill" className="h-12 w-auto" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-white transition-colors">
            <ArrowLeft className="w-4 h-4" />Vissza a főoldalra
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-[#3B82F6]/20 rounded-xl flex items-center justify-center">
            <Shield className="w-6 h-6 text-[#3B82F6]" />
          </div>
          <div>
            <p className="text-sm text-[#FF5722] font-bold uppercase tracking-wider">Pálfy György E.V.</p>
            <h1 className="text-3xl font-bold font-['Outfit']">Adatvédelmi tájékoztató</h1>
          </div>
        </div>

        <p className="text-sm text-[#94A3B8] mb-12 border-l-2 border-[#FF5722] pl-4">Hatályos: 2026. 04. 16. – visszavonásig, vagy módosításig</p>

        <div className="legal-content space-y-10">
          {/* 1. Adatkezelő */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">1. Adatkezelő adatai</h2>
            <div className="bg-[#121A2F] border border-white/10 rounded-xl p-6 space-y-2 text-sm">
              <p><span className="text-[#94A3B8]">Megnevezés:</span> Pálfy György e.v.</p>
              <p><span className="text-[#94A3B8]">Székhely:</span> 1195, Budapest, Batthyány utca 18 7/21</p>
              <p><span className="text-[#94A3B8]">Adószám:</span> 91974947-1-43</p>
              <p><span className="text-[#94A3B8]">Nyilvántartási szám:</span> 62187171</p>
              <p><span className="text-[#94A3B8]">Telefon:</span> +36 20 976 2300</p>
              <p><span className="text-[#94A3B8]">Email:</span> palfyvill@gmail.com</p>
            </div>
          </section>

          {/* 2. Adatvédelmi nyilatkozat */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">2. Adatvédelmi nyilatkozat</h2>
            <p className="text-[#CBD5E1] leading-relaxed mb-4">Ez az Adatvédelmi tájékoztató és nyilatkozat az Pálfy György e.v. (Adatkezelő) tevékenységére vonatkozóan tartalmazza az adatvédelemmel kapcsolatos információkat. Szolgáltatásunk igénybevétele során Ön megadja személyes adatait. Ezeket az adatokat a legnagyobb körültekintéssel, a jogszabályok előírásainak megfelelően kezeljük, és minden esetben igyekszünk az Ön adatkezeléssel kapcsolatos igényeinek és elvárásainak megfelelni.</p>
            <p className="text-[#CBD5E1] leading-relaxed mb-4">Az adatkezelési tevékenységünket meghatározó jogszabályok:</p>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>GDPR – (EU) 2016/679 rendelet</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2011. évi CXII. törvény (Infotv.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>Magyarország Alaptörvénye</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2013. évi V. törvény (Ptk.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2003. évi C. törvény (Eht.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2001. évi CVIII. törvény (Eker tv.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2017. évi CL. törvény (Art.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2000. évi C. törvény (Sztv.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>1997. évi CLV. törvény (Fogyv tv.)</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2008. évi XLVIII. törvény (Grtv.)</li>
            </ul>
          </section>

          {/* 3. Fogalmak */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">3. Fogalmak</h2>
            <div className="space-y-3 text-sm">
              {[
                ["GDPR", "Az Európai Parlament és a Tanács (EU) 2016/679 rendelete a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről."],
                ["Személyes adat", "Az érintettre vonatkozó bármely információ, például név, szám, helymeghatározó adat, online azonosító."],
                ["Adatkezelés", "A személyes adatokon végzett bármely művelet: gyűjtés, rögzítés, tárolás, felhasználás, törlés stb."],
                ["Adatkezelő", "Az a személy vagy szervezet, aki a személyes adatok kezelésének célját és eszközeit meghatározza."],
                ["Adatfeldolgozó", "Az a személy, aki az adatkezelő nevében személyes adatokat kezel."],
                ["Érintett", "Bármely azonosított vagy azonosítható természetes személy."],
                ["Adattovábbítás", "A személyes adat meghatározott harmadik személy számára történő hozzáférhetővé tétele."],
                ["Adatvédelmi incidens", "A biztonság olyan sérülése, amely személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését eredményezi."],
                ["NAIH", "Nemzeti Adatvédelmi és Információszabadság Hatóság."],
              ].map(([term, desc]) => (
                <div key={term} className="bg-[#121A2F] border border-white/5 rounded-lg p-4">
                  <p className="font-semibold text-[#FF5722] mb-1">{term}</p>
                  <p className="text-[#94A3B8]">{desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 4. Adatkezelés elvei */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">4. Az adatkezelés alapvető elvei</h2>
            <div className="space-y-2 text-sm text-[#CBD5E1]">
              {["Jogszerűség, tisztességes eljárás és átláthatóság", "Célhoz kötöttség", "Adattakarékosság", "Pontosság", "Korlátozott tárolhatóság", "Integritás és bizalmas jelleg", "Elszámoltathatóság"].map((elv) => (
                <div key={elv} className="flex items-start gap-3 p-3 bg-[#121A2F]/50 rounded-lg">
                  <div className="w-2 h-2 rounded-full bg-[#3B82F6] mt-1.5 flex-shrink-0"></div>
                  <p>{elv}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 5. Kezelt adatok */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">5. Kezelt adatok</h2>
            <h3 className="text-base font-semibold mb-3">5.1 Szolgáltatás megrendelése és időpontfoglalás</h3>
            <p className="text-sm text-[#94A3B8] mb-4">Érintettek: Azok a természetes/jogi személyek, akik a szolgáltatást megrendelik. Cél: Kapcsolattartás, a megrendelés teljesítése.</p>
            <div className="bg-[#121A2F] border border-white/10 rounded-xl overflow-hidden">
              <table className="w-full text-sm">
                <thead><tr className="border-b border-white/10">
                  <th className="text-left p-4 text-[#94A3B8] font-medium">Adatfajta</th>
                  <th className="text-left p-4 text-[#94A3B8] font-medium">Jogalap</th>
                  <th className="text-left p-4 text-[#94A3B8] font-medium">Őrzési idő</th>
                </tr></thead>
                <tbody>
                  {["Név", "E-mail cím", "Telefonszám", "Lakcím", "Időpont"].map((adat, i) => (
                    <tr key={adat} className={i < 4 ? "border-b border-white/5" : ""}>
                      <td className="p-4">{adat}</td>
                      <td className="p-4 text-[#94A3B8]">{i === 0 ? "GDPR 6. cikk a) pont (hozzájárulás)" : ""}</td>
                      <td className="p-4 text-[#94A3B8]">{i === 0 ? "Hozzájárulás visszavonásáig" : ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-sm text-[#94A3B8] mt-4">A hozzájárulást bármikor indokolás nélkül visszavonhatja, ez azonban nem érinti a korábban történt adatkezeléseket.</p>
          </section>

          {/* 6. Adatok biztonsága */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">6. Az adatok biztonsága</h2>
            <p className="text-sm text-[#CBD5E1] leading-relaxed mb-4">Technikai és szervezési intézkedésekkel gondoskodunk az általunk kezelt személyes adatok biztonságáról. Az adatokat védjük a jogosulatlan hozzáférés, megváltoztatás, továbbítás, törlés vagy megsemmisítés ellen.</p>
          </section>

          {/* 7. Adatok továbbítása */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">7. Az adatok továbbítása, átadása</h2>
            <p className="text-sm text-[#CBD5E1] leading-relaxed mb-4">Az adatkezelésben közreműködő szerződéses partner:</p>
            <div className="bg-[#121A2F] border border-white/10 rounded-xl p-5 text-sm">
              <p className="font-semibold text-[#FF5722]">HighLevel Inc.</p>
              <p className="text-[#94A3B8] mt-1">400 North Saint Paul Street Suite 920, Dallas, TX 75201</p>
              <a href="https://storage.googleapis.com/msgsndr/knES3eSWYIsc5YSZ3YLl/media/6435747d41ff79e6e2117755.pdf" target="_blank" rel="noreferrer" className="text-[#3B82F6] hover:underline text-xs mt-1 block">Adatkezelési tájékoztató</a>
            </div>
          </section>

          {/* 8. Érintettek jogai */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">8. Az érintettek jogai</h2>
            <div className="space-y-4">
              {[
                ["8.1", "Előzetes tájékoztatáshoz való jog", "Az érintett jogosult arra, hogy az adatkezelés megkezdése előtt átláthatóan, érthetően tájékoztatást kapjon."],
                ["8.2", "A hozzáférés joga", "Az érintett jogosult visszajelzést kapni arra vonatkozóan, hogy személyes adatainak kezelése folyamatban van-e."],
                ["8.3", "A helyesbítéshez való jog", "Az érintett kérheti a pontatlan személyes adatok helyesbítését és a hiányos adatok kiegészítését."],
                ["8.4", "A törléshez való jog (\"elfeledtetéshez való jog\")", "Az érintett kérheti személyes adatai törlését, ha azokra már nincs szükség, vagy a hozzájárulást visszavonta."],
                ["8.5", "Az adatkezelés korlátozásához való jog", "Az érintett kérheti az adatkezelés korlátozását meghatározott esetekben."],
                ["8.6", "Értesítéshez való jog", "Az érintett kérheti a címzettek megadását, akikkel személyes adatait közölték."],
                ["8.7", "Adathordozhatósághoz való jog", "Az érintett jogosult adatait tagolt, géppel olvasható formátumban megkapni."],
                ["8.8", "A tiltakozáshoz való jog", "Az érintett bármikor tiltakozhat személyes adatainak kezelése ellen."],
                ["8.9", "Automatizált döntéshozatal", "Az érintett jogosult arra, hogy ne terjedjen ki rá kizárólag automatizált adatkezelésen alapuló döntés."],
                ["8.10", "Tájékoztatás adatvédelmi incidensről", "Az érintettnek joga van tájékoztatást kapni az őt érintő adatvédelmi incidensről."],
                ["8.11", "Panasztétel a felügyeleti hatóságnál", "Az érintett panaszt tehet a NAIH-nál (1055 Budapest, Falk Miksa u. 9-11, naih.hu)."],
                ["8.12", "Bírósági jogorvoslat", "Minden érintett jogosult hatékony bírósági jogorvoslatra a felügyeleti hatóság döntésével szemben."],
              ].map(([num, title, desc]) => (
                <div key={num} className="bg-[#121A2F]/50 border border-white/5 rounded-lg p-4">
                  <p className="font-semibold text-sm"><span className="text-[#FF5722] mr-2">{num}</span>{title}</p>
                  <p className="text-xs text-[#94A3B8] mt-1">{desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Elérhetőségek */}
          <section className="bg-[#121A2F] border border-[#3B82F6]/20 rounded-xl p-6">
            <h2 className="text-lg font-bold font-['Outfit'] mb-3">Elérhetőségek a joggyakorlás érdekében</h2>
            <div className="space-y-2 text-sm">
              <p><span className="text-[#94A3B8]">Postai levélben:</span> Budapest, Batthyány utca 18 7/21</p>
              <p><span className="text-[#94A3B8]">E-mailben:</span> palfyvill@gmail.com</p>
              <p><span className="text-[#94A3B8]">Személyesen:</span> telefonon egyeztetett módon</p>
            </div>
            <p className="text-xs text-[#94A3B8] mt-4">Telefonon személyes adatokkal kapcsolatos információkat nem áll módunkban kiadni, mivel nem tudjuk azonosítani a hívó felet.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
